import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ListNote } from './listPage';

/**
 * "선택한 직원의 …만 보고 있습니다. 모두 보기" when a filter that arrives by link (직원 홈,
 * 고객 페르소나, 직원 관리) is in the URL. Those used to narrow the list with nothing on
 * screen saying so. `linked`: [query key, label] pairs, one per such filter on the page.
 */
const ScopeNote = ({ linked }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const qs = new URLSearchParams(location.search);
  const active = linked.filter(([key]) => qs.get(key));
  if (!active.length) return null;
  const clear = () => {
    linked.forEach(([key]) => qs.delete(key));
    qs.set('page', 1);
    navigate(`${location.pathname}?${qs.toString()}`);
  };
  return (
    <div style={{ margin: '12px 0' }}>
      <ListNote>
        {active.map(([, label]) => label).join(' · ')}만 보고 있습니다.{' '}
        <button type="button" onClick={clear} style={{ border: 'none', background: 'none', padding: 0, color: 'inherit', fontWeight: 600, textDecoration: 'underline', cursor: 'pointer', fontFamily: 'inherit', fontSize: 'inherit' }}>
          모두 보기
        </button>
      </ListNote>
    </div>
  );
};

export default ScopeNote;
